import { createContext, useContext, useEffect, useState } from "react";

const TenantContext = createContext();

export const TenantProvider = ({ children }) => {
  const [tenantId, setTenantIdState] = useState("");

  useEffect(() => {
    const savedTenantId = localStorage.getItem("selectedTenantId");
    if (savedTenantId) {
      setTenantIdState(savedTenantId);
    }
  }, []);

  const setTenantId = (id) => {
    setTenantIdState(id || "");
    if (id) {
      localStorage.setItem("selectedTenantId", id);
    } else {
      localStorage.removeItem("selectedTenantId");
    }
  };

  return (
    <TenantContext.Provider value={{ tenantId, setTenantId }}>
      {children}
    </TenantContext.Provider>
  );
};

export const useTenant = () => useContext(TenantContext);